import CookieAccepts from 'common/constants/cookieAccepts';

const getAcceptByCookie = (cookieAccept: CookieAccepts) =>
  document.cookie.includes(cookieAccept);

export default getAcceptByCookie;
